import React, { useEffect, useState, useMemo } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import Loadercomponent from "../../../../Componets/Loader";
import { get_ar_report } from "../../../../Controllers/Accounting/Services/ArReport";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Accounting/ReportEntry/ARReport/tables";
import headers from "../../../../Data/Tables/Accounting/ReportEntry/ARReport/headers";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Button } from "antd";


const ArReportTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      date: headerdata?.date,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      let from, to;
      if (tabledata?.date?.start && tabledata?.date?.end) {
        from = dayjs(tabledata.date.start).format("YYYY-MM-DD");
        to = dayjs(tabledata.date.end).format("YYYY-MM-DD");
      } else {
        from = dayjs().startOf("month").format("YYYY-MM-DD");
        to = dayjs().format("YYYY-MM-DD");
      }

      const response = await get_ar_report({
        from: from,
        to: to,
      });

      if (response?.success) {
        const arData = response.data || [];

        const tableBody = arData.map((item, index) => ({
          Customer: (
            <div>
              <div className="font-semibold">{item.customer_name}</div>
              <div className="text-sm text-gray-500">{item.customer_type}</div>
            </div>
          ),
          Contact: (
            <div>
              <div>{item.contact_name}</div>
              {item.contact_email && (
                <a
                  href={`mailto:${item.contact_email}`}
                  className="text-blue-600 text-sm"
                >
                  {item.contact_email}
                </a>
              )}
            </div>
          ),
          "Total Receivable": (
            <span className="font-semibold">
              {parseFloat(item.total_receivable || 0).toFixed(3)}
            </span>
          ),
          "0-30 Days": parseFloat(item.age_0_30 || 0).toFixed(3),
          "31-60 Days": parseFloat(item.age_31_60 || 0).toFixed(3),
          "61-90 Days": parseFloat(item.age_61_90 || 0).toFixed(3),
          "90+ Days": (
            <span
              className={
                item.age_90_plus > 0 ? "text-red-600 font-semibold" : ""
              }
            >
              {parseFloat(item.age_90_plus || 0).toFixed(3)}
            </span>
          ),
          Terms: item.payment_terms || "-",
          "Due Date": item.due_date
            ? dayjs(item.due_date).format("MMM DD, YYYY")
            : "-",
          Status: (
            <span
              className={`px-2 py-1 rounded text-xs font-semibold ${item.status === "current"
                ? "bg-blue-100 text-blue-800"
                : item.status === "overdue"
                  ? "bg-red-100 text-red-800"
                  : item.status === "paid"
                    ? "bg-green-100 text-green-800"
                    : item.status === "disputed"
                      ? "bg-orange-100 text-orange-800"
                      : "bg-gray-100 text-gray-800"
                }`}
            >
              {item.status === "current"
                ? "Current"
                : item.status === "overdue"
                  ? "Overdue"
                  : item.status === "paid"
                    ? "Paid"
                    : item.status === "disputed"
                      ? "Disputed"
                      : item.status}
            </span>
          ),
          Action: (
            <button
              onClick={() => handlePaymentReceipt(item)}
              disabled={item.status === "paid"}
              className={`px-3 py-1 rounded text-sm ${item.status === "paid"
                ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700"
                }`}
            >
              {item.status === "paid" ? "Paid" : "Record Payment"}
            </button>
          ),
        }));

        setBody(tableBody);

        setPagination({
          currentPage: 1,
          totalCount: arData.length,
          totalPages: Math.ceil(arData.length / 10),
        });

        setLoader(false);
      } else {
        setLoader(false);
        toast.error("Failed to load AR report data");
      }
    } catch (error) {
      setLoader(false);
      console.error("Failed to load AR report:", error.message);
      toast.error(error.message);
    }
  };

  const handlePaymentReceipt = (customer) => {
    console.log("Recording payment for:", customer.customer_name);
    toast.success(`Recording payment for ${customer.customer_name}`);
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  const exportPDF = async () => {
    try {
      const response = await get_ar_report({
        from: dayjs().startOf("month").format("YYYY-MM-DD"),
        to: dayjs().format("YYYY-MM-DD"),
      });

      if (response?.success) {
        const arData = response.data || [];
        const branch = response.branchInfo;

        const doc = new jsPDF();

        const pageWidth = doc.internal.pageSize.getWidth();

        doc.setFontSize(20);
        doc.setFont("helvetica", "bold");
        doc.text(branch?.name || "Organization Name", pageWidth / 2, 20, {
          align: "center",
        });

        doc.setFontSize(11);
        doc.setFont("helvetica", "normal");
        doc.text(
          `${branch?.email || ""} | ${branch?.phone || ""} | ${branch?.country || ""
          }`,
          pageWidth / 2,
          27,
          { align: "center" }
        );

        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text("Accounts Receivable Report", pageWidth / 2, 40, {
          align: "center",
        });

        autoTable(doc, {
          startY: 50,
          head: [
            [
              "Customer",
              "Total Receivable",
              "0-30 Days",
              "31-60 Days",
              "61-90 Days",
              "90+ Days",
              "Terms",
              "Status",
              "Due Date",
            ],
          ],
          body: arData.map((item) => [
            item.customer_name,
            (item.total_receivable || 0).toFixed(3),
            (item.age_0_30 || 0).toFixed(3),
            (item.age_31_60 || 0).toFixed(3),
            (item.age_61_90 || 0).toFixed(3),
            (item.age_90_plus || 0).toFixed(3),
            item.payment_terms || "-",
            item.status || "-",
            item.due_date ? dayjs(item.due_date).format("MMM DD, YYYY") : "-",
          ]),
          theme: "grid",
          styles: { fontSize: 9 },
          headStyles: { fillColor: [24, 144, 255] },
        });

        doc.save(`ar_report_${dayjs().format("YYYYMMDD")}.pdf`);
      }
    } catch (error) {
      console.error("Export PDF error:", error);
      toast.error("Failed to export PDF");
    }
  };

  return (
    <Header
      headers={header}
      setHeaders={setHeader}
      formdata={formdata}
      title="Accounts Receivable Report"
    >
      <div className="flex gap-3 justify-end mt-4">
        <Button
          onClick={exportPDF}
          className="text-medium form-save-button"
          type="primary"
        >
          Export as PDF
        </Button>
      </div>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ArReportTable;
